import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import Translation from "i18next";
import moment from "moment";

import { Col, Row } from "react-bootstrap";
import FlightSelectionSummaryDetail from "../../flight-selection/FlightSelectionSummaryDetail";
import { AirportFullName } from "../../../../service/shared/AirportFullName";
class PaymentSummaryTripDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTripDetail: true,
    };
  }
  parseTime = (minute) => {
    let hours = parseInt(minute / 60);
    let minutes = minute % 60;
    return <span>{hours + "hrs " + minutes + " mins"}</span>;
  };
  parseDate = (dateString) => {
    let options = {
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    let date = new Date(dateString);
    let newDate = date.toLocaleString("en-GB", options);
    return <span>{newDate}</span>;
  };
  renderStops(segments, stops) {
    if (stops > 0) {
      return (
        <div>
          {segments.map((segment, key) => (
            <span key={key}>
              {key !== 0 && (
                <span>
                  {stops}{" "}
                  <span>
                    {stops > 1 ? Translation.t("stops") : Translation.t("stop")}
                  </span>
                </span>
              )}
            </span>
          ))}
        </div>
      );
    } else {
      return <span>{Translation.t("non-stop")}</span>;
    }
  }
  getCityName(airport) {
    return AirportFullName.getCityName(airport);
  }
  render() {
    return (
      <section className="payment-summary-trip-detail">
        <h2
          className="payment-summary-trip-detail-head"
          onClick={() =>
            this.setState({ showTripDetail: !this.state.showTripDetail })
          }
        >
          <span>Your Trip Details</span>
          <span className="float-right">
            <FontAwesomeIcon
              icon={this.state.showTripDetail ? faAngleUp : faAngleDown}
            />
          </span>
        </h2>
        {this.state.showTripDetail && (
          <div className="trip-detail">
            {this.props.tripDetail.map((itineraryPart) => (
              <section className="payment-summary-trip-detail-list">
                <Row className="pt-3">
                  <Col xs={12} sm={12} md={12} lg={6}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={6}>
                        <span className="pr-4 airport-name">
                          {this.getCityName(itineraryPart.segments[0].origin)}
                        </span>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={6}>
                        <span className="pl-0 pl-md-4 airport-name">
                          {this.getCityName(
                            itineraryPart.segments[
                              itineraryPart.segments.length - 1
                            ].destination
                          )}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={6}>
                    <Row>
                      <Col>
                        <time className="pr-4">
                          {moment(itineraryPart.segments[0].departure).format(
                            "L"
                          )}
                        </time>
                      </Col>
                      <Col>
                        <time className="pl-4">
                          {" "}
                          {moment(itineraryPart.segments[0].arrival).format(
                            "L"
                          )}
                        </time>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={6}>
                    <Row>
                      <Col>
                        <h5>
                          <strong>
                            {" "}
                            <time className="pr-4">
                              {moment(
                                itineraryPart.segments[0].departure
                              ).format("hh:mm A")}
                            </time>
                          </strong>
                        </h5>
                      </Col>
                      <Col>
                        <h5>
                          <strong>
                            {" "}
                            <time className="pl-4">
                              {moment(itineraryPart.segments[0].arrival).format(
                                "hh:mm A"
                              )}
                            </time>
                          </strong>
                        </h5>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={3} className="text-center">
                    <h5>
                      <strong>
                        <time>
                          {" "}
                          {this.parseTime(itineraryPart.totalDuration)}
                        </time>
                      </strong>
                    </h5>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={5}></Col>
                  <Col xs={12} sm={12} md={12} lg={5} className="text-center">
                    <div>
                      <strong>Non-stop</strong>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {itineraryPart.segments.map((segment, index) => (
                      <div className="py-1" key={index}>
                        {segment.flight.airlineCode === "ET" && (
                          <img
                            className="custom-img-sm-flag"
                            src="data:image/png;base64,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"
                          />
                        )}
                        <span className="px-1">
                          {segment.flight.airlineCode}
                        </span>
                        <span className="pr-2">
                          {segment.flight.flightNumber}
                        </span>
                        <span className="pr-2">{segment.manufacturerName}</span>
                        <span>{segment.equipmentDescription}</span>
                      </div>
                    ))}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <FlightSelectionSummaryDetail
                      itineraryPart={itineraryPart}
                    />
                  </Col>
                </Row>
              </section>
            ))}
          </div>
        )}
      </section>
    );
  }
}
export default PaymentSummaryTripDetail;
